import React, {FC} from 'react';

import {QuoteItemV2} from 'api/magento/magentoAPI.schemas';
import {ProductsList} from 'components/miniCart/productsList/productsList';
import {MiniCartSkeleton} from 'components/miniCart/skeleton/skeleton';
import {MiniCartBottom} from 'desktopMiniCart/miniCartBottom/miniCartBottom';
import {MiniCartHeaderLogin} from 'desktopMiniCart/miniCartHeaderLogin/miniCartHeaderLogin';
import {useGetCustomerData} from 'hooks/getCustomerData/getCustomerData';

import s from './miniCartContent.scss';

type PropsType = {
    isLoading: boolean;
    items?: QuoteItemV2[];
};

/**
 * mini cart content
 */
export const MiniCartContent: FC<PropsType> = ({isLoading, items}) => {
    const customer = useGetCustomerData();

    return isLoading ? (
        <MiniCartSkeleton isLoggedIn={customer.is_logged_in} />
    ) : (
        <>
            <MiniCartHeaderLogin isLoggedIn={customer.is_logged_in} />
            {items && (
                <ProductsList
                    className={{
                        desktopContainer: s.desktopContainer,
                        dividerForDesktop: s.dividerForDesktop,
                    }}
                    items={items}
                />
            )}
            <MiniCartBottom items={items} />
        </>
    );
};
